import { AxiosResponse, AxiosError } from 'axios';
import {
    RequestedCreateProductAction,
    SucceededCreateProductAction,
    FailedCreateProductAction,
    RequestedUpdateProductAction,
    SucceededUpdateProductAction,
    FailedUpdateProductAction,
    RequestedDeleteProductAction,
    SucceededDeleteProductAction,
    FailedDeleteProductAction,
    ProductsState,
    SetProductAction,
    SetProductsAction,
    ProductId,
    PostProductPayload,
    PatchProductPayload,
    Product
} from './types';
import {
    PRODUCT_CREATE_REQUESTED,
    PRODUCT_CREATE_SUCCEEDED,
    PRODUCT_CREATE_FAILED,
    PRODUCT_UPDATE_REQUESTED,
    PRODUCT_UPDATE_SUCCEEDED,
    PRODUCT_UPDATE_FAILED,
    PRODUCT_DELETE_REQUESTED,
    PRODUCT_DELETE_SUCCEEDED,
    PRODUCT_DELETE_FAILED,
    PRODUCTS_SET,
    PRODUCT_SET
} from './constants';

export function createProduct(
    data: PostProductPayload
): RequestedCreateProductAction {
    return {
        type: PRODUCT_CREATE_REQUESTED,
        data,
        meta: {
            logentries: true
        }
    };
}

export function productCreated(
    response: AxiosResponse
): SucceededCreateProductAction {
    return {
        type: PRODUCT_CREATE_SUCCEEDED,
        payload: response
    };
}

export function failedCreateProduct(
    error: AxiosError
): FailedCreateProductAction {
    return {
        type: PRODUCT_CREATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestedUpdateProduct(
    productId: ProductId,
    product: PatchProductPayload
): RequestedUpdateProductAction {
    return {
        type: PRODUCT_UPDATE_REQUESTED,
        payload: {
            productId,
            product
        },
        meta: {
            logentries: true
        }
    };
}

export function succeededUpdateProduct(
    response: AxiosResponse
): SucceededUpdateProductAction {
    return {
        type: PRODUCT_UPDATE_SUCCEEDED,
        payload: response
    };
}

export function failedUpdateProduct(
    error: AxiosError
): FailedUpdateProductAction {
    return {
        type: PRODUCT_UPDATE_FAILED,
        payload: error,
        error: true
    };
}

export function requestedDeleteProduct(
    productId: ProductId
): RequestedDeleteProductAction {
    return {
        type: PRODUCT_DELETE_REQUESTED,
        payload: {
            productId
        }
    };
}

export function succeededDeleteProduct(
    response: AxiosResponse
): SucceededDeleteProductAction {
    return {
        type: PRODUCT_DELETE_SUCCEEDED,
        payload: response
    };
}

export function failedDeleteProduct(
    error: AxiosError
): FailedDeleteProductAction {
    return {
        type: PRODUCT_DELETE_FAILED,
        payload: error,
        error: true
    };
}

export function setProducts(products: ProductsState): SetProductsAction {
    return {
        type: PRODUCTS_SET,
        payload: products
    };
}

export function setProduct(product: Product): SetProductAction {
    return {
        type: PRODUCT_SET,
        payload: { [product.uuid]: product }
    };
}
